<template>
  <div
    class="organization-home"
    :class="{
      'h5-organization-home': isH5,
      'pc-organization-home': !isH5,
      'pad-app-h5-organization-home': isMGAppInPad && isH5,
    }"
  >
    <div class="bg-img-wrap">
      <img
        class="bg-img-bg"
        v-if="baseInfo.content_list[0]?.org_bg_pic"
        :src="orgBgPic + '|imageMogr2/blur/50x50'"
        alt=""
      />
      <img class="bg-img" :src="orgBgPic" alt="背景图" />
    </div>
    <div class="page-cont">
      <div class="org-info-wrap">
        <div class="org-info">
          <img class="org-logo" :src="orgLogo" alt="logo" />
          <div class="org-name-wrap">
            <p class="org-name">
              {{ baseInfo.content_list[0]?.org_name }}
            </p>
            <p class="introduce">
              {{ baseInfo.content_list[0]?.org_desc }}
            </p>
          </div>
        </div>
        <el-input
          class="search-input"
          placeholder="搜索课程"
          size="medium"
          v-model.trim="keyword"
          @keyup.enter.native="onSearch"
          maxlength="100"
        >
          <i
            :slot="isH5 ? 'prefix' : 'suffix'"
            class="el-input__icon el-icon-search"
            @click.stop="onSearch"
          ></i>
        </el-input>
      </div>

      <div class="recommend-content">
        <component
          :class="{ 'flash-background': +flashId === +item.id }"
          :ref="item.id"
          v-for="(item, index) in homePage"
          class="module-item"
          :key="item.id + index"
          :is="handleComponent(item.module_type)"
          :moduleInfo="item"
          :iosInReview="$route.query.inReview === '1'"
          :disableOperation="Boolean($route.query.is_preview)"
        >
        </component>
      </div>
    </div>
  </div>
</template>

<script>
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import {
  isH5,
  isMGAppInPad,
  handleImageUrl,
  isMobile,
  getCdnUrl,
} from "@saas/components/src";

import {
  getOrganizationHome,
  getOrganization,
} from "@saas/service-api/src/organization";
import PromotionVideo from "./components/PromotionVideo.vue";
import RecommendCourse from "./components/RecommendCourse";
import NavIcon from "./components/NavIcon.vue";
import PromotionImages from "./components/PromotionImages";
import CourseList from "./components/CourseList.vue";
import TeacherList from "./components/TeacherList";
export default {
  data: function () {
    return {
      isMobile: isMobile(),
      isMGAppInPad: true,
      isH5: isH5(),
      keyword: "",
      orgInfo: {},
      homePage: [],
      // 基本信息模块
      baseInfo: {
        content_list: [],
      },
      moduleList: [
        {
          module_type: 1,
          components: "nav-icon",
        },
        {
          module_type: 2,
          components: "promotion-images",
        },
        {
          module_type: 3,
          components: "promotion-video",
        },
        {
          module_type: 4,
          // components: "recommend-course",
          components: "course-list",
        },
        {
          module_type: 5,
          components: "teacher-list",
        },
      ],
      flashId: 0,
      courseModuleIds: [],
    };
  },
  beforeDestroy() {
    window.removeEventListener("message", this.previewRefresh);
    document.removeEventListener("click", this.handlerClickEvent, true);
  },
  mounted() {
    this.isMGAppInPad = isMGAppInPad();
    // 获取主页装修
    this.apiGetOrganizationHome();
    // 获取机构信息
    this.apiGetOrganization();
    window.addEventListener("message", this.previewRefresh);
    if (this.$route.query.is_preview) {
      this.setScrollBar();
      // 禁止所有点击事件
      document.addEventListener("click", this.handlerClickEvent, true);
    }
  },
  methods: {
    jumpOrgCoursesPage() {
      let url = `/org-courses/${this.$route.params.org_id}`;
      if (this.$route.query.inReview === "1") {
        url += `?inReview=1`;
      }
      if (window.isElectron || this.isMobile) {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
    handlerClickEvent(event) {
      event = event || window.event; //设置兼容性
      event.preventDefault
        ? event.preventDefault()
        : (event.retrunValue = false); //设置兼容性
      event.stopPropragation
        ? event.stopPropragation()
        : (event.cancelBubble = true); //设置兼容性
    },
    setScrollBar() {
      // 设置滚动条样式 滚动条宽度为0
      const element = document.body || document.documentElement;
      element.classList.add("hidden-scrollbar");
    },
    previewRefresh(event) {
      if (event.data.type === "refresh") {
        let params = {
          org_id: this.$route.params.org_id,
        };
        if (this.$route.query.is_preview) {
          params.is_preview = this.$route.query.is_preview;
        }
        getOrganizationHome(params).then((res) => {
          if (res.code === 1) {
            // 处理推荐课程列表-获取课程信息
            // let modles = res.data.map((item) => {
            //   return item.module_type;
            // });
            this.homePage = this.handleHomeData(res.data || []);
            this.$nextTick(() => {
              const data = event.data;
              this.flashId = data.id;
              if (this.flashId) {
                if (this.courseModuleIds.includes(this.flashId)) {
                  this.flashId = this.courseModuleIds[0];
                  this.$refs[`${this.flashId}`][0].type = data.id;
                }
                const dom = this.$refs[`${this.flashId}`][0].$el;
                const rect = dom.getBoundingClientRect();
                var scrollTop =
                  document.documentElement.scrollTop || document.body.scrollTop;
                window.scrollTo({
                  top: rect.top + scrollTop,
                  behavior: "smooth",
                });
                setTimeout(() => {
                  this.flashId = 0;
                }, 2000);
              }
            });
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    handleComponent(type) {
      return (
        this.moduleList.filter((item) => {
          return item.module_type === type;
        })[0]?.components || ""
      );
    },
    apiGetOrganization() {
      getOrganization({ org_id: this.$route.params.org_id }).then((res) => {
        if (res.code === 1 && res.data) {
          this.orgInfo = res.data;
          let { org_name, org_desc } = res.data;
          // 修改页面标题
          document.title = org_name;
          jsToFlutter("setTitle", { title: document.title });
          // 修改描述
          if (org_desc) {
            document
              ?.querySelector('meta[name="description"]')
              ?.setAttribute("content", org_desc);
          }
        }
      });
    },
    apiGetOrganizationHome() {
      let params = {
        org_id: this.$route.params.org_id,
      };
      if (this.$route.query.is_preview) {
        params.is_preview = this.$route.query.is_preview;
      }
      getOrganizationHome(params).then((res) => {
        if (res.code === 1) {
          this.homePage = this.handleHomeData(res.data || []);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleHomeData(data) {
      this.baseInfo = data.find((item) => item.module_type === 6) || {
        content_list: [],
      };
      // 推荐课程组件数据处理
      let courseLists = data.filter((item) => {
        return item.module_type === 4;
      });
      if (courseLists?.length) {
        this.courseModuleIds = courseLists.map((item) => {
          return item.id;
        });
        let firstId = courseLists[0].id;
        for (let index = 0; index < data.length; index++) {
          let item = data[index];
          if (item.module_type === 4) {
            if (item.id === firstId) {
              // 将配置的所有推荐课程数据-都归为第一组推荐课程里
              item.moduleList = JSON.parse(JSON.stringify(courseLists));
              item.moduleIds = this.courseModuleIds;
            } else {
              data.splice(index, 1);
              index--;
            }
          }
        }
      } else {
        // 没有配置推荐课程
        data.push({
          module_type: 4,
          id: new Date().getTime(),
        });
      }
      console.log(data, "data=========");
      return data;
    },
    onSearch() {
      if (this.keyword && !this.$route.query.is_preview) {
        let url = `/org-courses/${this.$route.params.org_id}?keyword=${this.keyword}`;
        if (this.$route.query?.inReview === "1") {
          url += `&inReview=1`;
        }
        if (window.isElectron || this.isMobile) {
          this.$router.push(url);
        } else {
          window.open(url);
        }
      }
    },
  },
  computed: {
    orgBgPic() {
      if (this.baseInfo.content_list[0]?.org_bg_pic) {
        return handleImageUrl(
          this.baseInfo.content_list[0].org_bg_pic + "?imageView2/0/w/1000"
        );
      } else {
        return require("../../assets/images/organization/org_bg.png");
      }
    },
    orgLogo() {
      if (this.baseInfo.content_list[0]?.org_logo) {
        return handleImageUrl(
          this.baseInfo.content_list[0]?.org_logo + "?imageView2/0/w/160"
        );
      } else {
        return getCdnUrl("/cdn/static/images/default_org_logo.png", "?imageView2/0/w/100", "comettech");
      }
    },
  },
  components: {
    "promotion-images": PromotionImages,
    "nav-icon": NavIcon,
    "recommend-course": RecommendCourse,
    "promotion-video": PromotionVideo,
    "course-list": CourseList,
    "teacher-list": TeacherList,
  },
};
</script>
<style lang="scss">
// .h5-organization-home,
// .pc-organization-home {
//   background-color: #fff;
//   padding-bottom: 1px;
// }
.hidden-scrollbar {
  scrollbar-width: 0;
  /* 标准语法，Firefox 支持 */
  -ms-overflow-style: none;

  /* IE 和 Edge */
  &::-webkit-scrollbar {
    display: none;
    /* WebKit 内核浏览器 */
  }
}
</style>
<style lang="scss" scoped>
.pad-app-h5-organization-home {
  width: 375px !important;
  margin: 0 auto;
}
.pc-organization-home {
  --org-home-page-bg: #fafafa;
  --org-home-card-bg: #ffffff;
  --org-home-control-bg: #fafafa;
  --org-home-primary: #000000;
  --org-home-secondary: #515350;
  --org-home-input-text: #0d1400;
  --org-home-placeholder: #888988;
  --org-home-border: #e2e2e2;

  html.dark & {
    --org-home-page-bg: var(--mg-bg-page);
    --org-home-card-bg: var(--mg-bg-card);
    --org-home-control-bg: var(--mg-control-bg);
    --org-home-primary: var(--mg-text-primary);
    --org-home-secondary: var(--mg-text-secondary);
    --org-home-input-text: var(--mg-text-primary);
    --org-home-placeholder: var(--mg-text-muted);
    --org-home-border: var(--mg-border-subtle);
  }

  background: var(--org-home-page-bg);
  width: 100%;
  min-height: calc(100vh - 255px);
  .bg-img-wrap {
    position: relative;
    background: #d4f1e1;
    height: 340px;
    .bg-img-bg {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .bg-img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 800px;
      height: 340px;
      object-fit: cover;
    }
  }
  .page-cont {
    position: relative;
    top: -20px;
    max-width: 800px;
    width: 800px;
    margin: 0 auto;
  }
  .org-info-wrap {
    position: relative;
    top: -20px;
    padding: 20px;
    border-radius: 24px;
    background: var(--org-home-card-bg);
    padding: 20px 24px;

    .org-logo {
      width: 80px;
      height: 80px;
      border-radius: 16px;
      border: 1px solid var(--org-home-border);
      margin-right: 16px;
      object-fit: cover;
    }
    .org-info {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      .org-name-wrap {
        width: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .org-name {
        font-weight: 500;
        font-size: 20px;
        color: var(--org-home-primary);
        line-height: 28px;
        word-break: break-all;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .introduce {
        font-weight: 400;
        font-size: 16px;
        color: var(--org-home-secondary);
        line-height: 22px;
        margin-top: 6px;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
    .search-input {
      color: var(--org-home-input-text);
    }
    ::v-deep .search-input input {
      background: var(--org-home-control-bg);
      border-radius: 8px;
      color: var(--org-home-input-text);
    }
    ::v-deep .el-input__inner {
      border: none;
    }
    ::v-deep .el-input__inner::placeholder {
      color: var(--org-home-placeholder);
    }
  }
  .recommend-content > div {
    padding-bottom: 30px;
  }
}

// 适配
.h5-organization-home {
  --org-home-page-bg: #fafafa;
  --org-home-card-bg: #ffffff;
  --org-home-control-bg: #fafafa;
  --org-home-primary: #0d1400;
  --org-home-secondary: #515350;
  --org-home-input-text: #0d1400;
  --org-home-placeholder: #888988;
  --org-home-border: #e2e2e2;

  html.dark & {
    --org-home-page-bg: var(--mg-bg-page);
    --org-home-card-bg: var(--mg-bg-card);
    --org-home-control-bg: var(--mg-control-bg);
    --org-home-primary: var(--mg-text-primary);
    --org-home-secondary: var(--mg-text-secondary);
    --org-home-input-text: var(--mg-text-primary);
    --org-home-placeholder: var(--mg-text-muted);
    --org-home-border: var(--mg-border-subtle);
  }

  background: var(--org-home-page-bg);
  width: 100%;
  min-height: calc(100vh - 3.4rem);
  .bg-img-wrap {
    position: relative;
    background: #d4f1e1;
    height: 4.24rem;
    .bg-img-bg {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .bg-img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 10rem;
      height: 4.24rem;
      object-fit: cover;
    }
  }
  .page-cont {
    position: relative;
    top: -0.13rem;
    max-width: 100%;
    width: 100%;
    margin: 0 auto;
    padding: 0 0.32rem;
  }
  .org-info-wrap {
    position: relative;
    top: -0.27rem;
    padding: 20px;
    border-radius: 0.32rem;
    background: var(--org-home-card-bg);
    padding: 0.32rem 0.27rem 0.27rem;

    .org-logo {
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 0.21rem;
      border: 0.01rem solid var(--org-home-border);
      margin-right: 0.16rem;
      object-fit: cover;
    }
    .org-info {
      display: flex;
      align-items: center;
      margin-bottom: 0.21rem;
      .org-name-wrap {
        width: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .org-name {
        font-weight: 500;
        font-size: 0.4rem;
        color: var(--org-home-primary);
        line-height: 0.56rem;
        word-break: break-all;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .introduce {
        font-weight: 400;
        font-size: 0.29rem;
        color: var(--org-home-secondary);
        line-height: 0.4rem;
        margin-top: 0.13rem;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
    .search-input {
      color: var(--org-home-input-text);
    }
    ::v-deep .search-input input {
      background: var(--org-home-control-bg);
      border-radius: 0.21rem;
      color: var(--org-home-input-text);
    }
    ::v-deep .el-input__inner {
      border: none;
    }
    ::v-deep .el-input__inner::placeholder {
      color: var(--org-home-placeholder);
    }
  }
  .recommend-content > div {
    padding-bottom: 0.27rem;
  }
}

@keyframes flashBackground {
  0% {
    background-color: initial;
  }

  50% {
    background-color:
               /* 选择你要闪现的颜色，例如 */ #ff730054;
  }

  100% {
    background-color: initial;
  }
}
.flash-background {
  animation: flashBackground 0.5s ease-in-out 0s 2;
  /* 参数说明：
        - flashBackground：引用之前定义的关键帧动画名称
        - 0.5s：动画总持续时间，可根据需求调整
        - ease-in-out：动画速度曲线，可替换为其他类型
        - 0s：动画延迟时间，此处设为立即开始
        - 2：动画重复次数，设为 2 以实现闪两下效果
     */
}
</style>
<style lang="scss">
// 公共样式-标题
// .pc-organization-home {
//   .recommend-content {
//     .content-title {
//       font-weight: 500;
//       font-size: 24px;
//       line-height: 33px;
//     }
//     & > div {
//       margin-bottom: 32px;
//     }
//   }
// }
// .h5-organization-home {
//   .recommend-content {
//     .content-title {
//       font-weight: 600;
//       font-size: 0.48rem;
//       line-height: 0.67rem;
//     }
//     & > div {
//       margin-bottom: 1.07rem;
//     }
//   }
// }
</style>
